import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { c as e } from "../../../chunks/mat3f32.js";
import t from "../../../layers/effects/EffectView.js";
import { DisplayObject as i } from "./DisplayObject.js";

var s = /*#__PURE__*/function (_i) {
  _inherits(s, _i);

  var _super = _createSuper(s);

  function s() {
    var _this;

    _classCallCheck(this, s);

    _this = _super.apply(this, arguments), _this._childrenSet = new Set(), _this._needsSort = !1, _this.children = [], _this._effectView = null;
    return _this;
  }

  _createClass(s, [{
    key: "blendMode",
    get: function get() {
      return this._blendMode;
    },
    set: function set(e) {
      this._blendMode = e, this.requestRender();
    }
  }, {
    key: "clips",
    get: function get() {
      return this._clips;
    },
    set: function set(e) {
      this._clips = e, this.children.forEach(function (t) {
        return t.clips = e;
      });
    }
  }, {
    key: "computedEffects",
    get: function get() {
      var e, t;
      return null != (e = null == (t = this._effectView) ? void 0 : t.effects) ? e : null;
    }
  }, {
    key: "effect",
    get: function get() {
      var e, t;
      return null != (e = null == (t = this._effectView) ? void 0 : t.effect) ? e : "";
    },
    set: function set(e) {
      (this._effectView || e) && (this._effectView || (this._effectView = new t()), this._effectView.effect = e, this.requestRender());
    }
  }, {
    key: "updateTransitionProperties",
    value: function updateTransitionProperties(e, t) {
      _get(_getPrototypeOf(s.prototype), "updateTransitionProperties", this).call(this, e, t), this._effectView && (this._effectView.transitionStep(e, t), this._effectView.transitioning && this.requestRender());
    }
  }, {
    key: "doRender",
    value: function doRender(e) {
      var t = this.createRenderParams(e);
      this.renderChildren(t);
    }
  }, {
    key: "addChild",
    value: function addChild(e) {
      return this.addChildAt(e, this.children.length);
    }
  }, {
    key: "addChildAt",
    value: function addChildAt(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.children.length;
      if (!e) return e;
      if (this.contains(e)) return e;
      this._needsSort = !0;
      var i = e.parent;
      return i && i !== this && i.removeChild(e), t >= this.children.length ? this.children.push(e) : this.children.splice(t, 0, e), this._childrenSet.add(e), e.parent = this, e.stage = this.stage, this !== this.stage && (e.clips = this.clips), this.requestRender(), e;
    }
  }, {
    key: "contains",
    value: function contains(e) {
      return this._childrenSet.has(e);
    }
  }, {
    key: "removeAllChildren",
    value: function removeAllChildren() {
      this._childrenSet.clear(), this._needsSort = !0;

      var _iterator = _createForOfIteratorHelper(this.children),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _e = _step.value;
          this !== this.stage && (_e.clips = null), _e.stage = null, _e.parent = null;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.children.length = 0;
    }
  }, {
    key: "removeChild",
    value: function removeChild(e) {
      return this.contains(e) ? this.removeChildAt(this.children.indexOf(e)) : e;
    }
  }, {
    key: "removeChildAt",
    value: function removeChildAt(e) {
      if (e < 0 || e >= this.children.length) return null;
      this._needsSort = !0;
      var t = this.children.splice(e, 1)[0];
      return this._childrenSet.delete(t), this !== this.stage && (t.clips = null), t.stage = null, t.parent = null, t;
    }
  }, {
    key: "sortChildren",
    value: function sortChildren(e) {
      this._needsSort && (this.children.sort(e), this._needsSort = !1);
    }
  }, {
    key: "_createTransforms",
    value: function _createTransforms() {
      return {
        dvs: e()
      };
    }
  }, {
    key: "onAttach",
    value: function onAttach() {
      _get(_getPrototypeOf(s.prototype), "onAttach", this).call(this);

      var e = this.stage;

      var _iterator2 = _createForOfIteratorHelper(this.children),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _t = _step2.value;
          _t.stage = e;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "onDetach",
    value: function onDetach() {
      _get(_getPrototypeOf(s.prototype), "onDetach", this).call(this);

      var _iterator3 = _createForOfIteratorHelper(this.children),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _e2 = _step3.value;
          _e2.stage = null;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "renderChildren",
    value: function renderChildren(e) {
      var _iterator4 = _createForOfIteratorHelper(this.children),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _t2 = _step4.value;

          _t2.beforeRender(e);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      var _iterator5 = _createForOfIteratorHelper(this.children),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _t3 = _step5.value;

          _t3.processRender(e);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      var _iterator6 = _createForOfIteratorHelper(this.children),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _t4 = _step6.value;

          _t4.afterRender(e);
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
    }
  }, {
    key: "createRenderParams",
    value: function createRenderParams(e) {
      return _objectSpread(_objectSpread({}, e), {}, {
        blendMode: this.blendMode,
        effects: this.computedEffects,
        globalOpacity: e.globalOpacity * this.computedOpacity,
        inFadeTransition: this.inFadeTransition
      });
    }
  }]);

  return s;
}(i);

export { s as Container };